const state = {
  breadcrumbs: [],
};

export { state };
